import { createFileRoute } from '@tanstack/react-router'
import { PublicLayout } from '@/components/layouts/PublicLayout'
import { Hero } from '@/components/landing/Hero'
import { FeaturesSection } from '@/components/landing/FeaturesSection'
import { StudioFeaturesSection } from '@/components/landing/StudioFeaturesSection'

export const Route = createFileRoute('/')({
  component: LandingPage,
  head: () => ({
    meta: [
      {
        title: 'AerialFlow - Track Your Aerial Journey & Manage Your Studio',
      },
      {
        name: 'description',
        content:
          'Master your aerial skills with confidence. Track your progress, set goals, and manage your studio with AerialFlow. Modern platform for aerial silks, hoop, sling, and circus arts training.',
      },
      {
        name: 'keywords',
        content: 'aerial training, aerial silks, aerial hoop, lyra, circus arts, aerial fitness, studio management, class scheduling, aerial progress tracking, silks training, hoop training',
      },
      {
        property: 'og:type',
        content: 'website',
      },
      {
        property: 'og:url',
        content: 'https://aerialflow.com',
      },
      {
        property: 'og:title',
        content: 'AerialFlow - Track Your Aerial Journey & Manage Your Studio',
      },
      {
        property: 'og:description',
        content:
          'Track your aerial training, manage your studio, and achieve your goals with AerialFlow. Modern platform for aerial silks, hoop, sling, and circus arts.',
      },
      {
        property: 'og:site_name',
        content: 'AerialFlow',
      },
      {
        name: 'twitter:card',
        content: 'summary_large_image',
      },
      {
        name: 'twitter:title',
        content: 'AerialFlow - Track Your Aerial Journey',
      },
      {
        name: 'twitter:description',
        content: 'Master your aerial skills with confidence. Track progress, set goals, and manage your studio.',
      },
    ],
  }),
})

function LandingPage() {
  return (
    <PublicLayout>
      <Hero />
      <FeaturesSection />
      <StudioFeaturesSection />
    </PublicLayout>
  )
}
